module.exports = __webpack_public_path__ + "static/media/july.14fa2611.png";